import React, { useState } from 'react';
import Icon from '../../../common/Icon';
import MetadataViewer from '../../../metadata/MetadataViewer';
import CalendarEventViewer from '../../../metadata/CalendarEventViewer';
import { associatedMetadata } from '../../constants/submissionShow';
import { sortByAlpha, sortable } from '../../../../helpers/sorters';

const SelectValue = ({
  field,
  response,
  isEditing,
  adminField,
  handleResponseOptionUpdate,
  displayAdminQuotas,
}) => {
  const [viewMeta, setViewMeta] = useState(false);
  const [viewEvent, setViewEvent] = useState(false);
  const alphaSorted = field.alpha || false;
  const width =
    field.width === 1 ? 'full' : field.width === 2 ? 'half' : 'third';

  const sortedFieldOptions = alphaSorted
    ? sortByAlpha(field.options, 'value')
    : sortable(field.options);

  const responseOption = response
    ? field.options.find((opt) =>
        response.response_options.map((ro) => ro.option_id).includes(opt.id)
      )
    : null;

  const handleSelect = (e) => {
    let opt = field.options.find((opt) => opt.value == e.target.value);
    let optId = opt ? opt.id : null;
    handleResponseOptionUpdate(e, response, optId);
  };

  const optWithQuotaCounts = (option) => {
    return `${option.name} - (${option.response_options_count}/${option.local_quota})${option.hidden ? ' - Hidden from public' : ''}`;
  };

  return (
    <div className={'input-group ' + width}>
      <label
        className={responseOption || isEditing || adminField ? '' : 'empty'}
      >
        {field.name + ': '}
      </label>
      {adminField && field.help_text && (
        <p className='admin-help-text'>{field.help_text}</p>
      )}
      {isEditing || adminField ? (
        <>
          {associatedMetadata(field.metadata_entries, responseOption).length >
            0 && (
            <>
              <Icon
                icon='tag'
                title='View Metadata'
                onClick={() => {
                  setViewMeta(true);
                }}
              />
              <MetadataViewer
                viewMeta={viewMeta}
                setViewMeta={setViewMeta}
                metadata={associatedMetadata(
                  field.metadata_entries,
                  responseOption
                )}
                displayValue={responseOption ? responseOption.value : ''}
              />
            </>
          )}
          {responseOption?.calendar_event && (
            <>
              <Icon
                icon='calendar-check'
                title='View Calendar Event'
                onClick={() => setViewEvent(true)}
                faPrefix={'regular'}
              />
              <CalendarEventViewer
                viewEvent={viewEvent}
                setViewEvent={setViewEvent}
                calendarEvent={responseOption.calendar_event}
                displayValue={responseOption?.value || ''}
              />
            </>
          )}
          <div className='select-input'>
            <select
              value={responseOption ? responseOption.value : ''}
              onChange={handleSelect}
              style={{ backgroundColor: responseOption ? '#fff' : '#efbfc0' }}
            >
              <option
                id={field.id + '-null-option'}
                label='Please Select'
                value=''
              />
              {sortedFieldOptions.map((opt) => {
                return (
                  <option
                    label={
                      field.informs_global || displayAdminQuotas
                        ? optWithQuotaCounts(opt)
                        : opt.name
                    }
                    value={opt.value}
                    key={opt.id}
                  />
                );
              })}
            </select>
          </div>
        </>
      ) : responseOption ? (
        responseOption.value
      ) : (
        ''
      )}
    </div>
  );
};

export default SelectValue;
